import React from 'react';
import PropTypes from 'prop-types';

export default function QuestionIcon(props) {
  const { fill, size, opacity } = props;

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} opacity={opacity} viewBox='0 0 20 20'>
      <path fill='none' d='M0 0h20v20H0z' data-name='Retângulo 148054' />
      <path
        fill={fill}
        d='M10 2a8 8 0 1 0 8 8 8.009 8.009 0 0 0-8-8m0-1a9 9 0 1 1-9 9 9 9 0 0 1 9-9Z'
        data-name='Elipse 439'
      />
      <path
        fill={fill}
        d='M9.25 15h1.5v-1.667h-1.5ZM10 5a3.179 3.179 0 0 0-3 3.333h1.5A1.6 1.6 0 0 1 10 6.667a1.6 1.6 0 0 1 1.5 1.667c0 1.667-2.25 1.458-2.25 4.167h1.5c0-1.875 2.25-2.083 2.25-4.167A3.179 3.179 0 0 0 10 5Z'
      />
    </svg>
  );
}

QuestionIcon.defaultProps = {
  size: '20',
  fill: '#4b4b4b',
  opacity: '1',
};

QuestionIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string,
  opacity: PropTypes.oneOfType(PropTypes.string, PropTypes.number),
};
